import Marquee from "react-fast-marquee";

const ITEMS = ["OG ZERTIFIZIERT", "SEASON 1 GRAILS", "SOFORT-LIEFERUNG", "EPIC NAME VERIFIZIERT", "FULL ACCESS", "PAYPAL & KLARNA"];

export const TickerMarquee = () => {
  return (
    <section data-testid="marquee" className="relative border-y border-white/10 bg-[#0f0f11] py-6 overflow-hidden">
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-extrabold text-3xl md:text-5xl tracking-tight text-stroke px-8">
              {t}
            </span>
            <span className="text-[#e2ff00] text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
